var Keys;
(function (Keys) {
    Keys["TAB"] = "Tab";
    Keys["ENTER"] = "Enter";
    Keys["ESCAPE"] = "Escape";
    Keys["SPACE"] = " ";
    Keys["LEFT"] = "ArrowLeft";
    Keys["UP"] = "ArrowUp";
    Keys["RIGHT"] = "ArrowRight";
    Keys["DOWN"] = "ArrowDown";
    Keys["HOME"] = "Home";
    Keys["END"] = "End";
    Keys["PAGE_UP"] = "PageUp";
    Keys["PAGE_DOWN"] = "PageDown";
})(Keys || (Keys = {}));
export default Keys;
